<template>
  <div class="app-box avue-contail"  :class="{ 'avue--collapse': isCollapse }">
  

    <div class="avue-layout">
      <div class="avue-left">
        <!-- 左侧导航栏 -->
        <app-nav></app-nav>
      </div>
      <div class="avue-main">
        <!-- 主体视图层 -->
        <div
          style="height: 100%; overflow-y: auto; overflow-x: hidden;"
          id="avue-view"
          v-show="!isSearch"
        >
          <router-view
            class="content1"
            v-if="this.isShowHeadArray.includes(this.name)"
          ></router-view>

          <div class="content2" v-else>
            <app-head />
            <router-view class="avue-view"></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./sidebar/index";
import head from "./head";
import {mapGetters} from "vuex"
export default {
  name: "Layout",
  components: {
    "app-nav": Navbar,
    "app-head": head,
  },
  data() {
    return {
      path: "",
      name: "首页",
      isShowHeadArray: ["首页", "个人信息"],      isSearch: false,
    };
  },
  created() {
    this.name = this.$route.name;
    console.log(this.name,'namenamename')
  },
    computed: mapGetters([ "isCollapse"]),
  //监听路由是不是首页
  watch: {
    $route: {
      handler(val, oldval) {
        this.name = val.name;
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style scoped>
.content1 {
  position: fixed;
  left: 172px;
  top: 0;
  height: 100%;
  width: calc(100% - 20px);
  width: calc(100% - 172px);
  padding-bottom: 20px;
  overflow: auto;

  /* width: 100vw; */
  /* min-height: 100%;
    max-height: 100vh;
    overflow: hidden; */
  /* background: #0c1a3c; */
}
.content2 {
  position: fixed;
  left: 172px;
  top: 0;
  height: 100%;
  width: calc(100% - 172px);
  padding: 20px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue